var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000a3c;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200-.32C89.54-.32,0,89.22,0,199.68s89.54,200,200,200,200-89.54,200-200S310.46-.32,200-.32Zm-66.19,311.1h-45.04V159.53h45.04v151.25Zm-22.8-173.49c-15.01,0-26.69-12.23-26.69-27.25s11.68-27.25,26.69-27.25,27.25,12.23,27.25,27.25-12.23,27.25-27.25,27.25Zm200.18,94.53v78.96h-44.48v-81.74c-.56-17.24-12.23-30.58-29.47-30.58s-31.7,13.35-32.25,30.58v81.74h-44.48V159.53h44.48v21.13c9.45-13.9,25.02-22.8,42.82-22.8h12.23c28.36,0,51.16,23.35,51.16,51.16v22.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4a458e0fca5fd5b0751d7f625efa3aa7.svg";
export { ForwardRef as ReactComponent };